import script from "./SelectTenantPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectTenantPage.vue?vue&type=script&lang=ts&setup=true"

import "./SelectTenantPage.vue?vue&type=style&index=0&id=222d42d1&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222d42d1"]])

export default __exports__